export default __webpack_public_path__ + "media/51f47fc6d2ae8de225c20fd151d5152e92fee606b4ea9527bb57f96ebeb502d2.svg";